import { TABLE_COLUMN_WIDTH } from "components/ModelCompare/constants";

import type { Section } from "../types";
import { physicalSecurityProducts } from "./product-sets/physicalSecurityProducts";
import { physicalSecurityProperties } from "./property-sets/physicalSecurity";

export const PhysicalSecurityOverview: Section = {
  properties: physicalSecurityProperties,
  products: physicalSecurityProducts,
  columnWidth: TABLE_COLUMN_WIDTH,
  isOverviewPage: true,
  showBadges: true,
};
